import { render, staticRenderFns } from "./siDetail.vue?vue&type=template&id=6ceee8bc&"
import script from "./siDetail.vue?vue&type=script&lang=js&"
export * from "./siDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ceee8bc')) {
      api.createRecord('6ceee8bc', component.options)
    } else {
      api.reload('6ceee8bc', component.options)
    }
    module.hot.accept("./siDetail.vue?vue&type=template&id=6ceee8bc&", function () {
      api.rerender('6ceee8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/siDetail.vue"
export default component.exports